import type { ModelElement, OntologyClass } from '@/frontend/features/Fde/types'

export function elementPropertyValue(element: ModelElement, key: string) {
  return element.properties.find((property) => property.key === key)?.value
}

export function elementImageUrl(element: ModelElement) {
  if (element.image_url) return element.image_url

  const value = elementPropertyValue(element, 'logo_url')
  return typeof value === 'string' && value ? value : null
}

export function elementSubtitle(element: ModelElement) {
  const lineage = element.ontology_class?.lineage || []
  const keys = lineage.includes('pessoa')
    ? ['job_title', 'primary_email']
    : lineage.includes('processo')
      ? ['lifecycle_status', 'cadence']
      : lineage.includes('sistema')
        ? ['environment', 'criticality', 'vendor']
        : []
  const values = keys.map((key) => elementPropertyValue(element, key)).filter((value) => value !== undefined && value !== '')
  return values.slice(0, 2).join(' · ')
}

export function propertyValueMap(element: ModelElement | null) {
  return new Map((element?.properties || []).map((property) => [property.key, property.value]))
}

export function propertiesForClass(ontologyClass: OntologyClass | undefined, element: ModelElement | null) {
  const values = propertyValueMap(element)
  return (ontologyClass?.property_schema || []).map((definition) => ({
    key: definition.key,
    value: values.get(definition.key) ?? '',
    origin: element?.properties.find((property) => property.key === definition.key)?.origin ?? 'manual',
    status: element?.properties.find((property) => property.key === definition.key)?.status ?? 'confirmado',
  }))
}
